import React from 'react'
import CheckoutComponent from '../Components/Checkout/Checkout'

const Checkout = () => {
  return (
    <CheckoutComponent />
  )
}

export default Checkout